export enum WebhookScope {
  Team = 1,
  EventType = 2,
}
